import { SearchInputExpanded } from 'module/ui/components/atoms/input/search-input-expanded';
import styled from 'styled-components';

export const AccountHeaderWrapper = styled.div<{
  $isAccountPage?: boolean;
}>`
  display: flex;
  gap: var(--spacing-03);
  background: var(--white);
  position: sticky;
  padding: ${({ $isAccountPage }) =>
    $isAccountPage ? 'var(--spacing-05)' : '0px'};
  top: 0;
  z-index: 100;
`;

// Styled-components for Figma-like dropdown
export const SignalsDropdownMenu = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow:
    0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
    0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);
  padding: 8px;
  min-width: 260px;
`;

export const SignalsList = styled.div`
  max-height: 240px;
  overflow-y: auto;
`;

export const DropdownHeader = styled.div`
  padding: 8px;
  font-size: 12px;
  color: #6f6f6f;
  line-height: 16px;
  letter-spacing: 0px;
  font-weight: 600;
`;

export const SignalRow = styled.div<SignalRowProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  background: ${({ selected }) => (selected ? '#D0E2FF' : '#fff')};
  border-radius: 4px;
  font-size: 14px;
  color: #161616;
  margin: 2px 0px;
  transition: background 0.2s;
  &:hover {
    background: #f4f4f4;
  }
  .signal-name {
    flex: 1;
  }
`;

export const SignalRowNoBackground = styled(SignalRow)`
  background: none;
  cursor: default;
`;

export const SignalReasonsContainer = styled.div`
  padding-left: 32px;
`;

export const StyledSearchInput = styled(SearchInputExpanded)`
  input {
    padding: 7px 12px;
    border-radius: 8px;
    border: 1px solid #f2f2f2;
    font-size: 14px;
    color: #161616;
    &::placeholder {
      color: #a8a8a8;
      opacity: 1;
    }
  }
`;

interface SignalRowProps {
  selected: boolean;
}

export const ModalTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ModalFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const ModalFieldWrapperWithMargin = styled(ModalFieldWrapper)`
  margin-top: 24px;
`;
